<script>
  import { fade } from 'svelte/transition';
  import { Nav, Login } from '../components/account';
  import { contact, checkmarkCircle } from 'ionicons/icons/index.mjs';
  export let data;
  let account = data.account;
  let modal = false;
  function messageHandler(message) {
		if (message.detail.type == "modal") {
      modal = !modal;
    }
  }
</script>

<div class="container grid-xl">
  <Login modal={modal} on:message={messageHandler} />
  <Nav page="" account={account} on:message={messageHandler} />
  {#if account}
    <div class="empty" in:fade>
      <div class="empty-icon">
        <i class="svg">{@html checkmarkCircle.md}</i>
      </div>
      <p class="empty-title h5">Successfully subscribed</p>
      <p class="empty-subtitle">Thanks for being a customer.</p>
    </div>
  {:else}
    <div class="empty" in:fade>
      <div class="empty-icon">
        <i class="svg">{@html contact.md}</i>
      </div>
      <p class="empty-title h5">You are not signed in</p>
    </div>
  {/if}
</div>

<style>
  .empty {
    background-color: white;
  }
  .empty-icon {
    margin: auto;
    width: 200px;
  }
</style>